import type * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

/** Executes one active request per connector while allowing other connectors concurrently. */
export function concurrentByConnector<TRequest, TResponse>(
  requests$: rxjs.Observable<TRequest>,
  getConnectorId: (request: TRequest) => ents.core.integrations.Connector.Id,
  execute: (request: TRequest) => rxjs.Observable<TResponse>,
): rxjs.Observable<TResponse> {
  return requests$.pipe(
    rxjs.groupBy(getConnectorId),
    rxjs.mergeMap(connectorRequests$ =>
      connectorRequests$.pipe(rxjs.exhaustMap(execute)),
    ),
  )
}
